import { faStars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography, useTheme } from '@mui/material';
import { Formaters } from 'lib/Formaters';
import React from 'react';

interface IProps {
    points: number;
    subtitle: string;
    size?: "small" | "normal";
}

export const AwardPointsCard: React.FC<IProps> = ({ points, subtitle, size = "normal" }) => {

    const theme = useTheme();

    return <Stack direction="row" alignItems="center" spacing={2}>
        <FontAwesomeIcon
            icon={faStars}
            color={theme.palette.warning.main}
            style={{ fontSize: size == "small" ? 70 : 80 }}
        />
        <Stack direction="column" alignItems="center" spacing={1}>
            <Typography variant="h5" color="muted.main" fontSize="32px">
                <strong>{Formaters.localeNumber(points)}</strong>
            </Typography>
            <Typography variant="captionHeader" color="muted.main" textAlign="center" lineHeight="1.1em" sx={{ width: 110 }}>
                {subtitle}
            </Typography>
        </Stack>
    </Stack>;
};
